import {RoleSearchModel, RoleModel} from '@spa/api';

import {InArrayValidator, WhitespaceValidator} from '@spa/validators';

import {ColorCodesEnum, ComponentTypesEnum} from '../../app/shared/enums';
import {BaseControl, CheckboxControl, FilterControl} from '../../app/shared/classes';

import {ConfirmationData} from '../../app/entries/panel/classes/confirmation-data';
import {
    ReportTableData,
    ReportTableConfigInterface,
    ReportTableButtonTypesEnum,
    ReportTableActionMenuTypesEnum,
    ReportTableActionsEnum, ReportTableColumn,
} from '../../app/shared/components';

import {PanelSettingsRolesMessages} from '../messages';

export const RoleIdSelector = 'id';
export const RolesNameSelector = 'name';
export const RolesPermissionsArraySelector = 'permissions';
export const PanelSettingsRoleStorageId = 'PanelSettingsRolesComponent';
export const PanelSettingsRolesFilterControls = (): FilterControl[] => {
    return [
        new FilterControl({
            name: RoleSearchModel.getRoleNameSelector(),
            placeholder: 'Name',
            controls: [
                new BaseControl({
                    name: RoleSearchModel.getRoleNameSelector(),
                    value: null,
                    placeholder: 'Name',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 1
        })
    ];
};

export const PanelSettingsRolesDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<number>({
            colId: RoleModel.getIdSelector(),
            value: null,
            hidden: false

        }),
        new ReportTableData<string>({
            colId: RoleModel.getNameSelector(),
            value: null,
            hidden: false

        })
    ];
};

export const PanelSettingsRolesDataTableConfig = (deleteAllowed: boolean, editAllowed: boolean): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Id',
                selector: RoleModel.getIdSelector()
            }),
            new ReportTableColumn({
                label: 'Name',
                selector: RoleModel.getNameSelector()
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: deleteAllowed || editAllowed,
        actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
        actionMenuItems: [
            {
                buttonType: ReportTableButtonTypesEnum.Delete,
                action: ReportTableActionsEnum.Delete,
                allowed: deleteAllowed
            },
            {
                buttonType: ReportTableButtonTypesEnum.Edit,
                action: ReportTableActionsEnum.Edit,
                allowed: editAllowed
            }
        ]
    };
};

export const RolesNameControl = (value: string): BaseControl => {
    return new BaseControl({
        name: RolesNameSelector,
        value: !value ? null : value,
        placeholder: 'Role name',
        validators: [WhitespaceValidator()],
        componentType: ComponentTypesEnum.Text
    });
};

export const RolesCheckboxControl = (
    permissionId: number,
    allPermissionIds: number[],
    currentRolePermissionIds: number[]
): CheckboxControl => {
    return new CheckboxControl({
        name: null,
        value: permissionId,
        placeholder: '',
        validators: [InArrayValidator(allPermissionIds)],
        componentType: ComponentTypesEnum.Checkbox,
        checked: (currentRolePermissionIds.length > 0) && (currentRolePermissionIds.indexOf(permissionId) >= 0),
        color: ColorCodesEnum.Primary,
        expectBooleanValue: false
    });
};

export const ConfirmDeleteRoleData = (formattedName: string): ConfirmationData => {
    return new ConfirmationData(
        PanelSettingsRolesMessages.ConfirmDeleteRoleCaption.message,
        PanelSettingsRolesMessages.ConfirmDeleteRoleQuestion.message.replace('<<name>>', formattedName).trim()
    );
};
